import { create } from "zustand";

type SortOrder = "asc" | "desc";

type EoyChecksState = {
  selectedShelf: string | null;
  shelfSortOrder: SortOrder;
  setSelectedShelf: (shelf: string | null) => void;
  toggleShelfSortOrder: () => void;
  reset: () => void;
};

const initialState: Pick<EoyChecksState, "selectedShelf" | "shelfSortOrder"> = {
  selectedShelf: "all",
  shelfSortOrder: "asc",
};

export const useEoyChecksStore = create<EoyChecksState>()((set) => ({
  ...initialState,
  setSelectedShelf: (shelf) => set({ selectedShelf: shelf }),
  toggleShelfSortOrder: () =>
    set((state) => ({
      shelfSortOrder: state.shelfSortOrder === "asc" ? "desc" : "asc",
    })),
  reset: () => set(initialState),
}));
